import personPlaceholder from "../assets/images/new-placeholder.png";
import schemat1 from "../assets/images/schemat1.png";
import schemat2 from "../assets/images/schemat2.png";
import schemat3 from "../assets/images/schemat3.png";
import schemat4 from "../assets/images/schemat4.png";
import schemat5 from "../assets/images/schemat5.png";
import deliveryPickup from "../assets/images/dostawa1.png";
import deliveryDigital from "../assets/images/dostawa2.svg";
import deliveryPaczkomat from "../assets/images/dostawa3.png";
import trener1 from "../assets/images/trener1.png";
import trener2 from "../assets/images/trener2.png";
import trener3 from "../assets/images/trener3.png";
import trener4 from "../assets/images/trener4.png";
import trener5 from "../assets/images/trener5.png";
import trener6 from "../assets/images/trener6.png";
import trener7 from "../assets/images/trener7.png";
import trener8 from "../assets/images/trener8.png";
import trener9 from "../assets/images/trener9.png";
import trener10 from "../assets/images/trener10.png";
import trener11 from "../assets/images/trener11.png";
import trener12 from "../assets/images/trener12.png";
import trener13 from "../assets/images/trener13.png";
import trener14 from "../assets/images/trener14.png";
import trener15 from "../assets/images/trener15.png";
import zawodnik1 from "../assets/images/zawodnik1.png";
import zawodnik2 from "../assets/images/zawodnik2.png";
import zawodnik3 from "../assets/images/zawodnik3.png";
import zawodnik4 from "../assets/images/zawodnik4.png";
import zawodnik5 from "../assets/images/zawodnik5.png";
import zawodnik6 from "../assets/images/zawodnik6.png";
import zawodnik7 from "../assets/images/zawodnik7.png";
import zawodnik8 from "../assets/images/zawodnik8.png";
import zawodnik9 from "../assets/images/zawodnik9.png";
import zawodnik10 from "../assets/images/zawodnik10.png";
import zawodnik11 from "../assets/images/zawodnik11.png";
import zawodnik12 from "../assets/images/zawodnik12.png";
import zawodnik13 from "../assets/images/zawodnik13.png";
import zawodnik14 from "../assets/images/zawodnik14.png";
import zawodniczka1 from "../assets/images/zawodniczka1.png";
import zawodniczka2 from "../assets/images/zawodniczka2.png";
import zawodniczka3 from "../assets/images/zawodniczka3.png";
import zawodniczka4 from "../assets/images/zawodniczka4.png";
import zawodniczka5 from "../assets/images/zawodniczka5.png";
import zawodniczka6 from "../assets/images/zawodniczka6.png";

const encodeSeed = (seed: string) => encodeURIComponent(seed.trim() || "demo");

const TRAINER_PHOTOS = [
  trener1,
  trener2,
  trener3,
  trener4,
  trener5,
  trener6,
  trener7,
  trener8,
  trener9,
  trener10,
  trener11,
  trener12,
  trener13,
  trener14,
  trener15,
];

const MALE_PLAYER_PHOTOS = [
  zawodnik1,
  zawodnik2,
  zawodnik3,
  zawodnik4,
  zawodnik5,
  zawodnik6,
  zawodnik7,
  zawodnik8,
  zawodnik9,
  zawodnik10,
  zawodnik11,
  zawodnik12,
  zawodnik13,
  zawodnik14,
];

const FEMALE_PLAYER_PHOTOS = [
  zawodniczka1,
  zawodniczka2,
  zawodniczka3,
  zawodniczka4,
  zawodniczka5,
  zawodniczka6,
];

/** Kolejność = przypisanie do trener1…trener15 (każde zdjęcie użyte ≥1 raz). */
const TRAINER_IDS = [
  "00000000-0000-0000-0000-000000000201",
  "00000000-0000-0000-0000-000000000202",
  "00000000-0000-0000-0000-000000000203",
  "00000000-0000-0000-0000-000000000501",
  "00000000-0000-0000-0000-000000000502",
  "00000000-0000-0000-0000-000000000503",
  "00000000-0000-0000-0000-000000000504",
  "00000000-0000-0000-0000-000000000505",
  "00000000-0000-0000-0000-000000000601",
  "00000000-0000-0000-0000-000000000602",
  "00000000-0000-0000-0000-000000000603",
  "00000000-0000-0000-0000-000000000604",
  "00000000-0000-0000-0000-000000000605",
  "00000000-0000-0000-0000-000000000606",
  "00000000-0000-0000-0000-000000000607",
];

/** Kolejność = zawodnik1…14, potem powtórzenia. */
const MALE_PLAYER_IDS = [
  "00000000-0000-0000-0000-000000000101",
  "00000000-0000-0000-0000-000000000102",
  "00000000-0000-0000-0000-000000000103",
  "00000000-0000-0000-0000-000000000104",
  "00000000-0000-0000-0000-000000000201",
  "00000000-0000-0000-0000-000000000202",
  "00000000-0000-0000-0000-000000000203",
  "00000000-0000-0000-0000-000000000301",
  "00000000-0000-0000-0000-000000000302",
  "00000000-0000-0000-0000-000000000303",
  "00000000-0000-0000-0000-000000000401",
  "00000000-0000-0000-0000-000000000402",
  "00000000-0000-0000-0000-000000000403",
  "00000000-0000-0000-0000-000000000504",
  "00000000-0000-0000-0000-000000000505",
  "00000000-0000-0000-0000-000000000506",
  "00000000-0000-0000-0000-000000000507",
  "00000000-0000-0000-0000-000000000508",
];

/** Kolejność = zawodniczka1…6, potem powtórzenie. */
const FEMALE_PLAYER_IDS = [
  "00000000-0000-0000-0000-000000000701",
  "00000000-0000-0000-0000-000000000702",
  "00000000-0000-0000-0000-000000000703",
  "00000000-0000-0000-0000-000000000704",
  "00000000-0000-0000-0000-000000000705",
  "00000000-0000-0000-0000-000000000706",
  "00000000-0000-0000-0000-000000000707",
];

const buildPhotoMap = (ids: string[], photos: string[]) => {
  const map: Record<string, string> = {};
  ids.forEach((id, index) => {
    map[id] = photos[index % photos.length];
  });
  return map;
};

const trainerPhotoById = buildPhotoMap(TRAINER_IDS, TRAINER_PHOTOS);
const malePlayerPhotoById = buildPhotoMap(MALE_PLAYER_IDS, MALE_PLAYER_PHOTOS);
const femalePlayerPhotoById = buildPhotoMap(FEMALE_PLAYER_IDS, FEMALE_PLAYER_PHOTOS);

const hashIndex = (seed: string, modulo: number) => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return modulo > 0 ? hash % modulo : 0;
};

export type DemoPersonRole = "trainer" | "player" | "playerFemale";

export const demoTrainerPhoto = (seed?: string) => {
  if (!seed) return TRAINER_PHOTOS[0];
  return trainerPhotoById[seed] ?? TRAINER_PHOTOS[hashIndex(seed, TRAINER_PHOTOS.length)];
};

export const demoFemalePlayerPhoto = (seed?: string) => {
  if (!seed) return FEMALE_PLAYER_PHOTOS[0];
  return (
    femalePlayerPhotoById[seed] ??
    FEMALE_PLAYER_PHOTOS[hashIndex(seed, FEMALE_PLAYER_PHOTOS.length)]
  );
};

export const demoMalePlayerPhoto = (seed?: string) => {
  if (!seed) return MALE_PLAYER_PHOTOS[0];
  return (
    malePlayerPhotoById[seed] ?? MALE_PLAYER_PHOTOS[hashIndex(seed, MALE_PLAYER_PHOTOS.length)]
  );
};

export const isDemoFemalePlayerId = (seed?: string) =>
  Boolean(seed && (femalePlayerPhotoById[seed] || /00000000070[1-9]$/.test(seed)));

export const demoPlayerPhoto = (seed?: string) =>
  isDemoFemalePlayerId(seed) ? demoFemalePlayerPhoto(seed) : demoMalePlayerPhoto(seed);

/** Zdjęcie osoby — domyślnie zawodnik; dla trenerów podaj role: "trainer". */
export const demoAvatarPhoto = (seed?: string, _size?: number, role?: DemoPersonRole) => {
  if (role === "trainer") return demoTrainerPhoto(seed);
  if (role === "playerFemale") return demoFemalePlayerPhoto(seed);
  if (role === "player") return demoMalePlayerPhoto(seed);

  if (seed && femalePlayerPhotoById[seed]) return femalePlayerPhotoById[seed];
  if (seed && malePlayerPhotoById[seed]) return malePlayerPhotoById[seed];
  if (seed && trainerPhotoById[seed]) return trainerPhotoById[seed];

  return personPlaceholder;
};

export const demoAvatarPhotoMin = (seed?: string, role?: DemoPersonRole) =>
  demoAvatarPhoto(seed, undefined, role);

export const demoPhotoPair = (seed?: string, role?: DemoPersonRole) => ({
  PhotoFilePath: demoAvatarPhoto(seed, undefined, role),
  PhotoFilePathMin: demoAvatarPhotoMin(seed, role),
});

export const demoTrainerPhotoPair = (seed?: string) => demoPhotoPair(seed, "trainer");

export const demoPlayerPhotoPair = (seed?: string) => ({
  PhotoFilePath: demoPlayerPhoto(seed),
  PhotoFilePathMin: demoPlayerPhoto(seed),
});

export const demoFtpPhoto = (seed?: string, role?: DemoPersonRole) =>
  demoAvatarPhoto(seed, undefined, role);

export const demoAcademyLogo = (name: string) => {
  const label = encodeURIComponent(
    name
      .replace(/—.*/, "")
      .replace(/Klub piłkarski/i, "DA")
      .trim() || "Akademia"
  );
  return `https://ui-avatars.com/api/?name=${label}&background=1a3a52&color=9cb0c4&size=128&bold=true`;
};

export const demoGroupLogo = (name: string) => {
  const label = encodeURIComponent(name.trim() || "Grupa");
  return `https://ui-avatars.com/api/?name=${label}&background=2d4a63&color=e8f1f8&size=128&bold=true`;
};

export const demoProductBanner = (seed: string) =>
  `https://picsum.photos/seed/${encodeSeed(`product-${seed}`)}/640/360`;

const DELIVERY_ICONS_BY_ID: Record<string, string> = {
  "00000000-0000-0000-0000-000000000701": deliveryDigital,
  "00000000-0000-0000-0000-000000000702": deliveryPickup,
  "00000000-0000-0000-0000-000000000703": deliveryPaczkomat,
  "00000000-0000-0000-0000-000000000704": deliveryDigital,
  "00000000-0000-0000-0000-000000000705": deliveryPickup,
};

const DELIVERY_ICONS = [deliveryPickup, deliveryDigital, deliveryPaczkomat];

/** Ikony dostaw jak w Academiq (odbiór / digital / paczkomat). */
export const demoDeliveryPhoto = (seed: string) => {
  if (DELIVERY_ICONS_BY_ID[seed]) {
    return DELIVERY_ICONS_BY_ID[seed];
  }

  const normalized = seed.toLowerCase();
  if (normalized.includes("paczkomat") || normalized.includes("inpost")) {
    return deliveryPaczkomat;
  }
  if (normalized.includes("digital") || normalized.includes("elektron")) {
    return deliveryDigital;
  }
  if (normalized.includes("odbiór") || normalized.includes("odbior") || normalized.includes("pickup")) {
    return deliveryPickup;
  }

  return DELIVERY_ICONS[hashIndex(seed, DELIVERY_ICONS.length)];
};
export const demoConversationLogo = (options: {
  type: number;
  name: string;
  privateProfileId?: string;
  academyName?: string;
}) => {
  if (options.type === 0 && options.privateProfileId) {
    return demoAvatarPhoto(options.privateProfileId);
  }

  if (options.academyName) {
    return demoAcademyLogo(options.academyName);
  }

  return demoGroupLogo(options.name);
};

/** Schematy ćwiczeń w detalu konspektu (schemat1–schemat5). */
export const DEMO_CONCEPT_SCHEMA_IMAGES = [
  schemat1,
  schemat2,
  schemat3,
  schemat4,
  schemat5,
] as const;

/** Deterministyczny schemat pod ćwiczenie — wszystkie 5 plików w użyciu, reszta wymieszana. */
export const demoConceptSchemaImage = (seed: string) => {
  const index = hashIndex(seed, DEMO_CONCEPT_SCHEMA_IMAGES.length);
  return DEMO_CONCEPT_SCHEMA_IMAGES[index];
};
